import * as React from 'react'

import { MobileFilterPanel } from './MobileFilterPanel'
import { Body } from './styles'

export const FilterPanel = () => {
  return (
    <Body>
      <MobileFilterPanel />
    </Body>
  )
}
